import { render } from "./CouponCardSkeleton.vue?vue&type=template&id=f8e785ba&scoped=true"
import script from "./CouponCardSkeleton.vue?vue&type=script&lang=js"
export * from "./CouponCardSkeleton.vue?vue&type=script&lang=js"

import "./CouponCardSkeleton.vue?vue&type=style&index=0&id=f8e785ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e785ba"]])

export default __exports__